module.exports = __webpack_public_path__ + "static/media/delete.f88179cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/delete.svg
// module id = 7624
// module chunks = 0